module.exports = __webpack_public_path__ + "static/media/headphones.e2543309.svg";